"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteFile = exports.uploadFile = exports.resetUser = exports.deleteAccount = exports.removeAvatar = exports.uploadAvatar = exports.updateUser = exports.getUserAllData = exports.getFileError = exports.avatarError = exports.getUserError = exports.reset = exports.setUserAll = exports.getUser = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const api_1 = require("../../services/api");
const profileSlice_1 = require("./profileSlice");
const preloaderSlice_1 = require("../slices/preloaderSlice");
const serializers_1 = require("../../widgets/profile/utils/serializers");
const initialState = {};
const baseUrl = window.AppearMe.appConfigs.url;
const addFileUrl = 'file';
const removeFileUrl = '/deleteFileFromS3';
const fileDirAWS = 'https://s3.amazonaws.com/findalawyer/';
const completeBeforeDelete = `* Please delete or complete your requests before you delete your account.`;
const addDocUrl = 'upload-user-files';
const deleteDocUrl = '/delete-file';
const userSlice = toolkit_1.createSlice({
    name: 'user',
    initialState: initialState,
    reducers: {
        getUser: state => state = api_1.Auth.getStorageUser(),
        setUserAll: (state, action) => {
            state = action.payload;
            return state;
        },
        reset: (state) => {
            return initialState;
        },
        getUserError: (state, action) => action.payload,
        avatarError: (state, action) => action.payload,
        getFileError: (state, action) => action.payload
    }
});
_a = userSlice.actions, exports.getUser = _a.getUser, exports.setUserAll = _a.setUserAll, exports.reset = _a.reset, exports.getUserError = _a.getUserError, exports.avatarError = _a.avatarError, exports.getFileError = _a.getFileError;
const getUserAllData = (id, guest, loader = false) => async (dispatch) => {
    try {
        if (loader) {
            dispatch(preloaderSlice_1.showLoader());
        }
        const payload = await api_1.Auth.getUserAllData(id, guest);
        serializers_1.mutateUser(payload);
        await dispatch(exports.setUserAll(payload));
        profileSlice_1.setProfileUser(payload);
        if (payload.practiceAreasData) {
            dispatch(profileSlice_1.setOldPracticeArea(payload.practiceAreasData));
        }
        if (payload.userDocs) {
            dispatch(profileSlice_1.updateUserDocs(payload.userDocs));
            dispatch(profileSlice_1.setOriginUserDocs(payload.userDocs));
        }
        if (loader) {
            dispatch(preloaderSlice_1.hideLoader());
        }
    }
    catch (e) {
        dispatch(exports.getUserError(e));
        if (loader) {
            dispatch(preloaderSlice_1.hideLoader());
        }
    }
};
exports.getUserAllData = getUserAllData;
const updateUser = (data) => async (dispatch) => {
    try {
        await api_1.Auth.updateUser(data);
        await exports.getUserAllData(data, false);
    }
    catch (e) {
        dispatch(exports.avatarError(e));
    }
};
exports.updateUser = updateUser;
const uploadAvatar = (data) => async (dispatch) => {
    try {
        dispatch(profileSlice_1.showAvatarLoading({ avatarLoading: true }));
        const payload = await api_1.Auth.upload(addFileUrl, data);
        const newData = {
            imageUrl: fileDirAWS + payload.data.files[0].fd
        };
        await api_1.Auth.updateUser(newData, 'image');
        await dispatch(exports.getUserAllData(data.id, false));
        dispatch(profileSlice_1.showAvatarLoading({ avatarLoading: false }));
    }
    catch (e) {
        dispatch(exports.avatarError(e));
    }
};
exports.uploadAvatar = uploadAvatar;
const removeAvatar = (data) => async (dispatch) => {
    try {
        await api_1.Auth.updateUser({ imageUrl: null }, 'image');
        api_1.Auth.delete(removeFileUrl, { params: { userImage: data.imageUrl } });
        dispatch(exports.getUserAllData(data.id, false));
    }
    catch (e) {
        dispatch(exports.avatarError(e));
    }
};
exports.removeAvatar = removeAvatar;
const deleteAccount = () => async (dispatch) => {
    try {
        const data = await api_1.Auth.deleteUser({ checkCases: true });
        if (data === null || data === void 0 ? void 0 : data.hasCases) {
            dispatch(profileSlice_1.setGeneralError(completeBeforeDelete));
        }
        else {
            setTimeout(() => {
                window.AppearMe.Widgets.Events.emit('onUserChange', { hide: true });
                return window.location.href = '#/logout';
            }, 5000);
        }
    }
    catch (e) {
        return false;
    }
};
exports.deleteAccount = deleteAccount;
const resetUser = () => async (dispatch) => {
    dispatch(exports.reset());
};
exports.resetUser = resetUser;
const uploadFile = (data) => async (dispatch) => {
    var _a, _b, _c, _d;
    try {
        dispatch(profileSlice_1.showFileLoading(true));
        const upload = await api_1.Auth.upload(addDocUrl, data);
        const payload = await api_1.Auth.updateUserDocs(upload.data);
        dispatch(profileSlice_1.setUserDocs(payload));
        dispatch(profileSlice_1.setOriginUserDocs(payload));
        dispatch(profileSlice_1.setFileError(((_a = upload.data.fileError) === null || _a === void 0 ? void 0 : _a.message) || null));
        dispatch(profileSlice_1.showFileLoading(false));
    }
    catch (e) {
        if (((_b = e === null || e === void 0 ? void 0 : e.response) === null || _b === void 0 ? void 0 : _b.status) != 500) {
            dispatch(profileSlice_1.setFileError((_d = (_c = e === null || e === void 0 ? void 0 : e.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message));
        }
        dispatch(profileSlice_1.showFileLoading(false));
    }
};
exports.uploadFile = uploadFile;
const deleteFile = (data) => async (dispatch) => {
    dispatch(profileSlice_1.showFileLoading(true));
    const payload = await api_1.Auth.delete(deleteDocUrl, {
        fileUrl: data.fileUrl
    });
    dispatch(profileSlice_1.setUserDocs(payload));
    dispatch(profileSlice_1.setFileError(null));
    dispatch(profileSlice_1.showFileLoading(false));
};
exports.deleteFile = deleteFile;
exports.default = userSlice.reducer;
